import { lazy } from 'react';

import { authRoles } from 'app/auth';
import ShippingLabelContent from '../e-commerce/order/Dialogs/ShippingLabelContent';
import ShipmentCommunication from './shipment/ShipmentCommunication';
import Containers from './containermanagements/Containers';
import StaffListGate from '../staff/list/StaffListGate';
import OutboundShipmentsGate from '../staff/outbound/OutboundShipmentsGate';

const SupplierListGate = lazy(() => import('../supplier/list/SupplierListGate'));
const ShipmentOrder = lazy(() => import('./shipments/ShipmentOrder'));
const CalendarApp = lazy(() => import('./calendar/CalendarApp'));
const Shipment = lazy(() => import('./shipment/Shipment'));
const PackingSlip = lazy(() => import('./shipment/PackingSlip'));
const Shipments = lazy(() => import('./shipments/Shipments'));
const TrackingPage = lazy(() => import('./containermanagements/containertracking/TrackingPage'));
const ShipmentLoad = lazy(() => import('../shipmentLoad/ShipmentLoad'));

const BackofficeConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.supplier,
  routes: [
    {
      path: 'shipments/:shipmentId',
      element: <ShipmentOrder />,
    },
    {
      path: 'shipments/receive/:shipmentId',
      element: <ShipmentOrder type="receive" />,
    },
    {
      path: 'shipments/calendar',
      element: <CalendarApp />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'shipments/containers',
      element: <StaffListGate type="container" for="container" module="container_shipments" />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'outbound/shipments',
      // Admin, staff and sales get the redesigned list; warehouse keeps the old page.
      element: <OutboundShipmentsGate permissionModule="outbound_shipments"
        fallback={<Shipments type="outbound" permissionModule="outbound_shipments" />} />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'shipments/communication/:shipmentId',
      element: <ShipmentCommunication />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'outbound/print-label/:orderId',
      element: <ShippingLabelContent type="outbound" />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'shipments/details/:shipmentId',
      element: <Shipment />,
      auth: authRoles.withWarehouseStaff
    },
    {
      // PGSS-5750: Scan to load a customer shipment. PSG staff only, as the Check List it opens from.
      path: 'shipments/load/:shipmentId',
      element: <ShipmentLoad />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'shipments/print-label/:orderId',
      element: <ShippingLabelContent />,
      auth: authRoles.customer,
    },
    {
      path: 'shipments/packingSlip/:shipmentId/:orderId',
      element: <PackingSlip />,
      auth: authRoles.withWarehouseStaff
    },
    {
      path: 'container-management',
      // onlySupplier already; the gate keeps Containers for anyone else who reaches it.
      element: <SupplierListGate type="container-management" fallback={<Containers />} />,
      auth: authRoles.onlySupplier
    },
    {
      path: 'container-tracking',
      element: <TrackingPage />,
      auth: authRoles.customer
    },
  ],
};

export default BackofficeConfig;
